/* ELSORINE – gift auto-add, tier bar, FAQ, reels player */
(function () {
  var GIFT = 67938925117502;
  var origFetch = window.fetch.bind(window);
  var LV_HDR = { 'Content-Type': 'application/json', 'X-LV': '1' };

  function getCart() { return origFetch('/cart.js', { headers: { 'X-LV': '1' } }).then(function (r) { return r.json(); }); }
  function giftLine(cart) { return cart.items.filter(function (i) { return i.variant_id === GIFT; })[0]; }
  function bagCount(cart) { return cart.items.reduce(function (n, i) { return n + ((i.product_type === 'Bag' || i.product_type === 'Charm') && i.variant_id !== GIFT ? i.quantity : 0); }, 0); }
  function paidCount(cart) { return cart.items.reduce(function (n, i) { return n + (i.variant_id === GIFT ? 0 : i.quantity); }, 0); }

  function isAdd(u) { return /\/cart\/add(\.js)?(\?|$)/.test(u); }
  function isChange(u) { return /\/cart\/(change|update)(\.js)?(\?|$)/.test(u); }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var mine = init && init.headers && (init.headers['X-LV'] || (init.headers.get && init.headers.get('X-LV')));
    if (mine) return origFetch(input, init);
    if (isAdd(url)) {
      return getCart().then(function (cart) {
        if (giftLine(cart)) return;
        return origFetch('/cart/add.js', { method: 'POST', headers: LV_HDR, body: JSON.stringify({ items: [{ id: GIFT, quantity: 1 }] }) }).catch(function () {});
      }).catch(function () {}).then(function () { return origFetch(input, init); })
        .then(function (res) { setTimeout(refreshTier, 300); return res; });
    }
    if (isChange(url)) {
      return origFetch(input, init).then(function (res) {
        getCart().then(function (cart) {
          var g = giftLine(cart);
          if (g && paidCount(cart) === 0) {
            origFetch('/cart/change.js', { method: 'POST', headers: LV_HDR, body: JSON.stringify({ id: g.key, quantity: 0 }) }).then(function () { location.reload(); });
          } else if (g && g.quantity > 1) {
            origFetch('/cart/change.js', { method: 'POST', headers: LV_HDR, body: JSON.stringify({ id: g.key, quantity: 1 }) }).then(function () { location.reload(); });
          } else { refreshTier(); }
        });
        return res;
      });
    }
    return origFetch(input, init);
  };

  /* ---------- Tier bar inside cart drawer & cart page (2 items = 20%, 3+ = 30%; bags + charms) ---------- */
  function tierHTML(n) {
    var next = n < 2 ? 2 : n < 3 ? 3 : 0;
    var pct = { 2: 20, 3: 30 };
    var txt = next ? 'Add <strong>' + (next - n) + ' more item' + (next - n > 1 ? 's' : '') + '</strong> to unlock <strong>' + pct[next] + '% extra off</strong>'
                   : 'You unlocked the <strong>maximum 30% extra off</strong> 🎉';
    var fill = n >= 3 ? 66.67 : n === 2 ? 33.33 : n === 1 ? 16.67 : 0;
    var h = '<div class="lv-tierbar"><p class="lv-tierbar__text">' + txt + '</p><div class="lv-tierbar__track"><div class="lv-tierbar__fill" style="width:' + fill + '%"></div>';
    [2, 3].forEach(function (k, i) { h += '<span class="lv-tierbar__node' + (n >= k ? ' is-reached' : '') + '" style="left:' + (33.33 * (i + 1)) + '%">' + k + '</span>'; });
    h += '</div><div class="lv-tierbar__labels">';
    [['2 items 20% OFF', 2], ['3+ items 30% OFF', 3]].forEach(function (l, i) { h += '<span class="lv-tierbar__label' + (n >= l[1] ? ' is-reached' : '') + '" style="left:' + (33.33 * (i + 1)) + '%">' + l[0] + '</span>'; });
    return h + '</div></div>';
  }
  function refreshTier() {
    getCart().then(function (cart) {
      var n = bagCount(cart);
      document.querySelectorAll('cart-drawer .drawer__header, .cart__items').forEach(function (anchor) {
        var host = anchor.parentElement; if (!host) return;
        var ex = host.querySelector(':scope > .lv-tierbar'); if (ex) ex.remove();
        if (cart.item_count === 0) return;
        anchor.insertAdjacentHTML('afterend', tierHTML(n));
      });
    }).catch(function () {});
  }
  document.addEventListener('DOMContentLoaded', function () {
    refreshTier();
    var drawer = document.querySelector('cart-drawer');
    if (drawer) new MutationObserver(function (m) {
      if (m.some(function (x) { return Array.prototype.some.call(x.addedNodes, function (nd) { return nd.nodeType === 1 && !nd.classList.contains('lv-tierbar') && !(nd.closest && nd.closest('.lv-tierbar')); }); })) { clearTimeout(window.__lvT); window.__lvT = setTimeout(refreshTier, 150); }
    }).observe(drawer, { childList: true, subtree: true });
  });

  /* ---------- FAQ accordion ---------- */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('.loravienne-faq__question');
    if (!q) return;
    var ans = q.nextElementSibling, open = q.getAttribute('aria-expanded') === 'true';
    q.setAttribute('aria-expanded', open ? 'false' : 'true');
    ans.style.maxHeight = open ? '0px' : ans.scrollHeight + 'px';
  });

  /* ---------- Reels player ---------- */
  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-lv-open]');
    if (card) { openPlayer(card.closest('.lv-reels'), +card.dataset.lvOpen); return; }
  });
  function openPlayer(root, idx) {
    var p = document.getElementById(root.dataset.player); if (!p) return; if (p.parentElement !== document.body) document.body.appendChild(p);
    var vids = JSON.parse(root.dataset.videos), v = p.querySelector('video'), i = idx;
    function show() { v.src = vids[i]; v.play().catch(function () {}); p.querySelector('[data-prev]').disabled = i === 0; p.querySelector('[data-next]').disabled = i === vids.length - 1; }
    p.classList.add('is-open'); document.body.style.overflow = 'hidden'; show();
    p.onclick = function (e) {
      if (e.target.closest('[data-close]')) { v.pause(); p.classList.remove('is-open'); document.body.style.overflow = ''; }
      else if (e.target.closest('[data-prev]') && i > 0) { i--; show(); }
      else if (e.target.closest('[data-next]') && i < vids.length - 1) { i++; show(); }
      else if (e.target.closest('[data-sound]')) { v.muted = !v.muted; p.classList.toggle('is-unmuted', !v.muted); }
      else if (e.target.closest('[data-shop]')) { v.pause(); p.classList.remove('is-open'); document.body.style.overflow = ''; var b = document.querySelector('.product-form__submit'); if (b) b.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    };
  }
})();
